import { IEnergyManager } from './interfaces';

export class EnergyManagerService {
  private customEnergyManagerEvent: CustomEvent | undefined;

  public handleEnergyManager(energyDetail?: IEnergyManager): void {
    this.customEnergyManagerEvent = new CustomEvent('energyManagerNotificationEvent', {
      detail: energyDetail,
    });
    document.dispatchEvent(this.customEnergyManagerEvent);
  }
}
